var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "seekers-form" },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-default-6 col-v-tablet-12" },
          [
            _c("z-input", {
              ref: "last-name",
              attrs: {
                placeholder: "Фамилия*",
                name: "last-name",
                required: "",
              },
              model: {
                value: _vm.params["last-name"],
                callback: function ($$v) {
                  _vm.$set(_vm.params, "last-name", $$v)
                },
                expression: "params['last-name']",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-default-6 col-v-tablet-12" },
          [
            _c("z-input", {
              ref: "first-name",
              attrs: { placeholder: "Имя*", name: "first-name", required: "" },
              model: {
                value: _vm.params["first-name"],
                callback: function ($$v) {
                  _vm.$set(_vm.params, "first-name", $$v)
                },
                expression: "params['first-name']",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-default-6 col-v-tablet-12" },
          [
            _c("z-input", {
              ref: "middle-name",
              attrs: {
                placeholder: "Отчество*",
                name: "middle-name",
                required: "",
              },
              model: {
                value: _vm.params["middle-name"],
                callback: function ($$v) {
                  _vm.$set(_vm.params, "middle-name", $$v)
                },
                expression: "params['middle-name']",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-default-6 col-v-tablet-12" },
          [
            _c("z-input", {
              ref: "phone",
              attrs: {
                placeholder: "Номер телефона*",
                name: "phone",
                type: "tel",
                required: "",
                mask: "+7 (###) ###-##-##",
              },
              model: {
                value: _vm.params.phone,
                callback: function ($$v) {
                  _vm.$set(_vm.params, "phone", $$v)
                },
                expression: "params.phone",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-default-6 col-v-tablet-12" },
          [
            _c("z-input", {
              ref: "email",
              attrs: {
                placeholder: "Электронная почта",
                name: "email",
                type: "email",
              },
              model: {
                value: _vm.params.email,
                callback: function ($$v) {
                  _vm.$set(_vm.params, "email", $$v)
                },
                expression: "params.email",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-default-6 col-v-tablet-12" },
          [
            this.idv > 0
              ? _c("div", { staticClass: "z-input" }, [
                  _vm._v("\n                Желаемая должность"),
                  _c("br"),
                  _vm._v(_vm._s(_vm.params.position) + "\n                "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.params.position,
                        expression: "params.position",
                      },
                    ],
                    attrs: { type: "hidden" },
                    domProps: { value: _vm.params.position },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.params, "position", $event.target.value)
                      },
                    },
                  }),
                ])
              : _c("z-input", {
                  ref: "position",
                  attrs: {
                    placeholder: "Желаемая должность*",
                    name: "position",
                    required: "",
                  },
                  model: {
                    value: _vm.params.position,
                    callback: function ($$v) {
                      _vm.$set(_vm.params, "position", $$v)
                    },
                    expression: "params.position",
                  },
                }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("z-tabs", {
        staticClass: "u-bottom-margin--l u-top-margin--s-important",
        attrs: { "only-visual": "" },
        on: { "toggle-item": _vm.onTabChange },
        scopedSlots: _vm._u([
          {
            key: "label",
            fn: function () {
              return _vm._l(_vm.tabs, function (item) {
                return _c(
                  "z-tabs-label",
                  {
                    key: item.id,
                    attrs: { id: item.id, "initial-state": item.selected },
                  },
                  [_c("span", { domProps: { innerHTML: _vm._s(item.text) } })]
                )
              })
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _vm.type === "form"
        ? _c(
            "div",
            [
              _c(
                "z-caption",
                {
                  staticClass: "u-bottom-margin--xs",
                  attrs: { tag: "p", size: "m" },
                },
                [_vm._v("Личная информация")]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-default-6 col-v-tablet-12" },
                  [
                    _c("z-input", {
                      ref: "city",
                      attrs: {
                        placeholder: "Город проживания*",
                        name: "city",
                        required: "",
                      },
                      model: {
                        value: _vm.params["personal-data"][0].city,
                        callback: function ($$v) {
                          _vm.$set(_vm.params["personal-data"][0], "city", $$v)
                        },
                        expression: "params['personal-data'][0].city",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-default-6 col-v-tablet-12" },
                  [
                    _c("z-date-picker", {
                      ref: "birthday",
                      attrs: {
                        "value-type": "format",
                        placeholder: "Дата рождения*",
                        required: "",
                        name: "birthday",
                      },
                      model: {
                        value: _vm.params["personal-data"][0].birthday,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.params["personal-data"][0],
                            "birthday",
                            $$v
                          )
                        },
                        expression: "params['personal-data'][0].birthday",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "z-caption",
                {
                  staticClass: "u-top-margin--m u-bottom-margin--xs",
                  attrs: { tag: "p", size: "m" },
                },
                [_vm._v("Опыт работы")]
              ),
              _vm._v(" "),
              _c("seeker-block", {
                ref: "experience",
                attrs: {
                  component: "experience",
                  "btn-text": "Добавить место работы",
                },
                on: { change: _vm.onBlockDataChange },
              }),
              _vm._v(" "),
              _c(
                "z-caption",
                {
                  staticClass: "u-top-margin--m u-bottom-margin--xs",
                  attrs: { tag: "p", size: "m" },
                },
                [_vm._v("Образование")]
              ),
              _vm._v(" "),
              _c("seeker-block", {
                ref: "education",
                attrs: {
                  component: "education",
                  "btn-text": "Добавить место учёбы",
                },
                on: { change: _vm.onBlockDataChange },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "file"
        ? _c(
            "div",
            [
              _c("z-input-file", {
                ref: "resume-file",
                attrs: { name: "resume-file", required: "" },
                on: { change: _vm.onFileChange },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "trigger",
                      fn: function () {
                        return [
                          _c(
                            "z-button",
                            {
                              attrs: {
                                tag: "div",
                                kind: "secondary",
                                type: "button",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "right",
                                    fn: function () {
                                      return [
                                        _c("z-icon", {
                                          attrs: {
                                            name: "paper-clip",
                                            width: "24",
                                            height: "24",
                                          },
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                false,
                                3470711691
                              ),
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  "Загрузите резюме или сопроводительное письмо"
                                ),
                              ]),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  false,
                  4048374031
                ),
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "u-top-margin--2xs" },
        [
          _vm._v(
            "\n        Ваша личная информация обрабатывается отделами по подбору персонала, которые рассмотрят и обработают ваше заявление на объявленную вакансию и свяжутся с вами. Если Вам необходима дополнительная информация о том, как Ваша личная информация обрабатывается и используется рекрутинговыми командами Распадская угольная компания, ознакомьтесь с расширенным Положением о конфиденциальности данных, с которым можно ознакомиться по следующей "
          ),
          _c(
            "z-link",
            {
              attrs: {
                blank: "",
                href: "https://files.raspadskaya.com/files/ru/politica_privacy.pdf",
              },
            },
            [_vm._v("ссылке.")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "z-checkbox",
        {
          ref: "agreement",
          staticClass: "u-top-margin--m",
          attrs: {
            name: "agreement",
            required: "",
            checked: _vm.params.agreement,
          },
          on: { change: _vm.onBlockDataChange },
        },
        [
          _vm._v(
            "\n        Ставя галочку на против этой графы, Вы соглашаетесь на обработку и использование Вашей личной информации, как описано выше. Вы имеете право в любое время отозвать свое согласие или возразить против дальнейшей обработки Вашей личной информации.\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "seekers-form__buttons" },
        [
          _c("z-button", { on: { click: _vm.submit } }, [
            _vm._v("Отправить резюме"),
          ]),
          _vm._v(" "),
          _c(
            "z-button",
            { attrs: { kind: "secondary" }, on: { click: _vm.reset } },
            [_vm._v("Сбросить всё")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("z-modal", { attrs: { id: "success-modal" } }, [
        _c(
          "div",
          { staticClass: "seekers-form-success" },
          [
            _c("z-icon", {
              staticClass: "u-bottom-margin--m",
              attrs: { name: "worker", width: "96", height: "96" },
            }),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n                Спасибо за проявленный интерес к нашей компании! При положительном рассмотрении резюме мы свяжемся с Вами в течении 3-х рабочих дней.\n            "
              ),
            ]),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "p",
      { staticClass: "black-60-text u-top-margin--m text-size-2xs" },
      [
        _vm._v("\n        Поля, помеченные "),
        _c("span", { staticClass: "black-90-text" }, [_vm._v("*")]),
        _vm._v(" обязательны для заполнения\n    "),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }